import { NOTIFICATIONS, NOTIFICATIONS_HIDE, NOTIFICATIONS_UNREAD_COUNT } from './contants';

const initState = {
	notification: [],
	geNotificationsUnreadCount: [],
	geNotificationsHide: [],
}

const reducerNotifications = (state = initState, actions) => {
	switch (actions.type) {
		case NOTIFICATIONS:
			return {
				...state,
				notification: actions.payload.data,
			}
		case NOTIFICATIONS_UNREAD_COUNT:
			return {
				...state,
				notificationUnreadCount: actions.payload.data,
			}
		case NOTIFICATIONS_HIDE:
			return {
				...state,
				geNotificationsHide: actions.payload.data,
			}
		default:
			return state
	}
}
export default reducerNotifications
